module.exports = __webpack_public_path__ + "img/bee004.8395233f.svg";